const moment = require('moment-timezone')

function convertBrowserLocalToAccount (value, accountZoneId, format = 'YYYY-MM-DD HH:mm:ss') {
  if (value == null || value === '') {
    return value
  }
  const instant = moment(value).valueOf()
  return moment.tz(instant, accountZoneId).format(format)
}

function timeZonesMatchByOffset (accountZoneId, browserZoneId, atMs = Date.now()) {
  const at = moment(atMs)
  return moment.tz(at, accountZoneId).utcOffset() === moment.tz(at, browserZoneId).utcOffset()
}

module.exports = {
  convertBrowserLocalToAccount,
  timeZonesMatchByOffset,
}
